import { render, staticRenderFns } from "./newInsurance.vue?vue&type=template&id=54a47c7e"
import script from "./newInsurance.vue?vue&type=script&lang=js"
export * from "./newInsurance.vue?vue&type=script&lang=js"
import style0 from "./newInsurance.vue?vue&type=style&index=0&id=54a47c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports